import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoManifoldBadgeMono = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 125 108",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M31.2 41.7L0 71.1L21.3 83.4L31.2 41.7Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M60.4 11.2L41 0L3.79999 64.6L32.1 37.9L60.4 11.2Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M62.4 95.7L103.4 108V83.4L62.4 95.7Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M21.3 85.6V108H95.9L58.6 96.8L21.3 85.6Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M83.7 0L62.4 12.3L93.5 41.7L83.7 0Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M87.4 6.5L96.4 44.4L105.3 82.2L124.7 71.1L87.4 6.5Z" })
	]
});
export default SvgLogoManifoldBadgeMono;
